import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NativeGeocoder, NativeGeocoderOptions, NativeGeocoderResult } from '@ionic-native/native-geocoder/ngx';
import { Globals } from '../globals';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { LoadingController, ModalController, NavController } from '@ionic/angular';
import { MapComponent } from '../map/map.component';
import { NewAddressComponent } from '../new-address/new-address.component';
import { UserService } from '../user.service';
import { loadOpt } from 'src/environments/environment';
import { RestService } from '../rest.service';
import { TouchSequence } from 'selenium-webdriver';
import { Storage } from '@ionic/storage-angular';
import { AlertController } from '@ionic/angular';//NUEVO YOLANDA
import { Device } from '@ionic-native/device/ngx';//NUEVO YOLANDA

declare var google: any;


@Component({
  selector: 'app-new-map',
  templateUrl: './new-map.component.html',
  styleUrls: ['./new-map.component.scss'],
})
export class NewMapComponent implements OnInit {

  @ViewChild('map',  {static: false}) mapElement: ElementRef;
  map: any;
  address: string;
  cp: string;
  lat: string;
  lng: string;
  autocomplete: { input: string; };
  autocompleteItems: any[];
  location: any;
  placeid: any;
  GoogleAutocomplete: any;
  direcciones: any[];
  actual: string;
  myModal: any;
  num: string;
  
  // Andy
  address_select: string;

  constructor(
    private geolocation: Geolocation,
    private nativeGeocoder: NativeGeocoder,
    public zone: NgZone,
    private route: Router,
    public global: Globals,
    public nav: NavController,
    public modalController: ModalController,
    public user: UserService,
    private stop: LoadingController,
    private rest: RestService,
    public storage: Storage,
    private alertCtrl:AlertController,//NUEVO YOLANDA
    private device: Device,//NUEVO YOLANDA
  
  ){
    this.storage.create();
    this.GoogleAutocomplete = new google.maps.places.AutocompleteService();
    this.autocomplete = { input: '' };
    this.autocompleteItems = [];
  }

  // CARGAMOS EL MAPA EN ONINIT
  async ngOnInit() {
    let platform = this.device.platform
    if(platform=="ios" ||platform=="android" ){
      this.checkLocationStatus();//NUEVO YOLANDA
    }else{
      this.loadMap();
    }
    //this.loadMap();//la llamo ahora en checkLocationStatus
  }

  //CHEQUEAR PERMISOS DE UBICACION
  async checkLocationStatus() {
    console.log('Dentro checkLocationStatus.');
  
    try {
      const position = await this.geolocation.getCurrentPosition();
      console.log('La ubicación está habilitada. Coordenadas:', position.coords.latitude, position.coords.longitude);
      this.loadMap();

    } catch (error) {
      console.log('Error al obtener la ubicación. Es posible que la ubicación esté deshabilitada en el dispositivo.', error);
  
      const alert = await this.alertCtrl.create({
        header: 'Ubicación deshabilitada',
        message: 'La ubicación está deshabilitada en su dispositivo. Habilite la ubicación en la configuración del dispositivo, para que funcione la carga del mapa.',
        buttons: [
          {
            text: 'OK',
            handler: () => {
              // Puedes agregar lógica adicional aquí si es necesario.
              console.log('Vamos a retroceder.****');

              this.redirectToAppSettings();
            }
          }
        ]
      });
  
      await alert.present();
    }
  }

  redirectToAppSettings() {
    // Redirige al usuario a la configuración de permisos en el dispositivo.
    // La implementación específica puede variar según la plataforma (iOS o Android).
    // Asegúrate de guiar al usuario a la sección de permisos de ubicación.
  this.nav.back;// Esto forzará el cierre de la aplicación
  

  }
  // CARGAR EL MAPA TIENE DOS PARTES
  async loadMap(coordsDone = null, latitud = null, longitud = null) {
    // OBTENEMOS LAS COORDENADAS DESDE EL TELEFONO.
    //console.log(latitud)
    //console.log(longitud)
    const loading = await this.stop.create(loadOpt);
    await loading.present();
    this.geolocation.getCurrentPosition().then(async (resp) => {
      var latLng;
      if (coordsDone) {
        if (latitud != null && longitud != null) {          
          latLng = new google.maps.LatLng(latitud, longitud);

        } else {
          const url = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + this.address + ", " + this.num + " " + this.cp + '&region=es&key=AIzaSyAaRRiNeQc1xLWeLLhohM7JX6Ti8Si38vs';
          await fetch(url)
            .then((resp) => resp.json())
            .then((respJson) => {
              const lat = respJson.results[0].geometry.location.lat;
              const lng = respJson.results[0].geometry.location.lng;
              latLng = new google.maps.LatLng(lat, lng);
            })
        }
      } else {
        latLng = new google.maps.LatLng(resp.coords.latitude, resp.coords.longitude);
      } 
      
      var mapOptions = {
        center: latLng,
        zoom: 17,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: true,
      };
      const mapa = document.getElementById('map_center');
      const infoMapa = document.getElementById('infoMapa');
      const confirmarDireccion = document.getElementById('confirmarDireccion');
      
      

      this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
      this.lat = this.map.center.lat();
      this.lng = this.map.center.lng();
      loading.dismiss();

      const url = 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + this.lat + ',' + this.lng + '&key=AIzaSyAaRRiNeQc1xLWeLLhohM7JX6Ti8Si38vs';
      fetch(url)
        .then((response) => response.json())
        .then((responseJson) => {
        this.lat = this.map.center.lat();
        this.lng = this.map.center.lng();
        this.global.lat = this.lat;
        this.global.lng = this.lng;
        // console.log(responseJson.results[0].address_components);
        this.autocomplete.input = responseJson.results[0].address_components[1].long_name;
        mapa.style.display = 'block';

        responseJson.results[0].address_components.filter((numero) => {
          if (numero.types[0] == 'street_number' ) {
            this.num = numero.long_name
          }
        });

        responseJson.results[0].address_components.filter((cp) => {
          if (cp.types[0] == 'postal_code') {
            this.cp = cp.long_name
          }
        });
        
        let calle = responseJson.results[0].address_components[1].long_name;
        this.address = calle;
        infoMapa.innerHTML = calle;

      });

      // CUANDO TENEMOS LAS COORDENADAS SIMPLEMENTE NECESITAMOS PASAR AL MAPA DE GOOGLE TODOS LOS PARAMETROS.
      this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
      this.map.addListener('drag', () => { 
        infoMapa.innerHTML = 'Buscando...'
        confirmarDireccion.style.display = 'none';
        infoMapa.classList.add('buscandoAnimado');
      });
      this.map.addListener('dragend', () => { // dragend es un evento de la api de google maps, el evento se ejecuta cuando terminas de desplazar el mapa.
        this.lat = this.map.center.lat();     // https://developers.google.com/maps/documentation/javascript/events
        this.lng = this.map.center.lng();
        this.global.lat = this.lat;
        this.global.lng = this.lng;
        this.global.puerta_map = '';
        

        const url = 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + this.lat + ',' + this.lng + '&key=AIzaSyAaRRiNeQc1xLWeLLhohM7JX6Ti8Si38vs';
        fetch(url)
        .then((response) => response.json())
        .then((responseJson) => {
          console.log(responseJson)
        this.recogerDatos(responseJson)
      });


        
      });

      this.map.addListener('zoom_changed', () => { // zoom_changed es un evento de la api de google maps, el evento se ejecuta cuando cambias el zoom en el mapa.
        this.lat = this.map.center.lat();
        this.lng = this.map.center.lng();
        this.global.lat = this.lat;
        this.global.lng = this.lng;
        this.global.puerta_map = '';

        const url = 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + this.lat + ',' + this.lng + '&key=AIzaSyAaRRiNeQc1xLWeLLhohM7JX6Ti8Si38vs';
        fetch(url)
        .then((response) => response.json())
        .then((responseJson) => {
          this.recogerDatos(responseJson)

        });
      });

    }).catch((error) => {
      console.log('Error getting location', error);
    });

  }

  goToCommerces(){
    this.nav.navigateForward(['tabs/tab1']);
  }

  async loadComponent(cp = null, num = null, address = null){
    this.usarDireccion();
    const modal = await this.modalController.create({
      component: NewAddressComponent,
      swipeToClose: true,
      mode: 'ios',
      backdropDismiss: true,
      cssClass: 'small-modal',
      componentProps: {
        address: address,
        cp: cp,
        num: num
      }
    });
    this.global.showPred = false;
    await modal.present()
  }

  usarDireccion(){
    let objetoInicial = {
      address: "",
      district: null,
      door: "",
      id_address: 0,
      lat: "",
      lng: "",
      number: "",
      postal_code: "",
      primary: "",
      state: "",
      user_id: ""
    }
    this.storage.set('actual_address', objetoInicial)
    const infoMapa = document.getElementById('infoMapa'); 
    this.address = infoMapa.textContent;
    this.global.address_map = this.address;
  }

  recogerDatos(responseJson){
    const infoMapa = document.getElementById('infoMapa');
    const confirmarDireccion = document.getElementById('confirmarDireccion');

    responseJson.results[0].address_components.filter((numero) => {
      if (numero.types[0] == 'street_number' ) {
        this.num = numero.long_name
      }
    });

    responseJson.results[0].address_components.filter((cp) => {
      if (cp.types[0] == 'postal_code') {
        this.cp = cp.long_name
      }
    });

    responseJson.results[0].address_components.filter((calle) => {
      calle.types[0] == 'route' 
        ? this.address = calle.long_name
        : {}
    });
    
    infoMapa.innerHTML = this.address;
    infoMapa.classList.remove('buscandoAnimado');
    confirmarDireccion.style.display = 'block';
  }

  enviarDireccion(){
    let direccion = this.user.adressesUser.filter((address) => 
      address.address + ' ' + address.number == this.address_select
    );
    this.address = direccion[0].address;
    this.num = direccion[0].number;
    this.cp = direccion[0].postal_code;
    this.global.puerta_map = direccion[0].door;
    this.storage.set('actual_address', direccion[0]);
    this.loadMap(true, direccion[0].lat, direccion[0].lng);
  }

}
